import React from 'react';
import BreadcrumbsInterface from 'interfaces/breadcrumbs.interface';

interface BreadcrumbsStructuralDataInterface {
    '@context': string;
    '@type': string;
    itemListElement?: [
            {
                '@type': string;
                'position': number;
                'name': string;
            } | {
            '@type': string;
            'position': number;
            'name': string;
            'item': string;
        }
    ];
}

const BreadcrumbsStructuralData: React.FC<{ breadcrumbs: BreadcrumbsInterface[]; }> = ({ breadcrumbs }) => {
    const itemListElement: any = [];

    breadcrumbs.forEach((breadcrumb, idx: number) => {
        const url = breadcrumb.url ? `https://www.skapiec.pl${breadcrumb.url}` : void 0;

        if (breadcrumb.name) {
            itemListElement.push({
                '@type': 'ListItem',
                'position': idx + 1,
                'name': breadcrumb.name,
                'item': url

            });
        } else {
            itemListElement.push({
                '@type': 'ListItem',
                'position': idx + 1,
                'name': url
            });
        }
    });

    const data: BreadcrumbsStructuralDataInterface = {
        '@context': 'http://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement
    };

    return (
        <script
            dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
            type="application/ld+json"
        />
    );
};

export default BreadcrumbsStructuralData;
